import StockContainer from "src/container/stock";
import { Helmet } from "react-helmet-async";

const Stock = () => {
  return (
    <>
      <Helmet>
        <title>텔레모아::핵심 텔레그램 채널의 중요 정보를 모아!</title>
        <meta name="description" content="오늘 주식시장은 어떤 종목이 주도할까? 가장 많이 커버 된 종목을 텔레모아에서 공개!" />
      </Helmet>
      <div className="container mt-4">
        <div className="row">
          <StockContainer rowPerPage={20} />
        </div>
      </div>
    </>
  );
}

export default Stock;
